import { FormHelperText, FormHelperTextProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { AppointmentFormData } from '../../../types'

type Props = FormHelperTextProps & {
  message: string
}

const headShake = `
  @keyframes headShake {
    0% {
      transform: translateX(0);
    }

    6.5% {
      transform: translateX(-6px) rotateY(-9deg);
    }

    18.5% {
      transform: translateX(5px) rotateY(7deg);
    }

    31.5% {
      transform: translateX(-3px) rotateY(-5deg);
    }

    43.5% {
      transform: translateX(2px) rotateY(3deg);
    }

    50% {
      transform: translateX(0);
    }
  }

  animation-delay: 0s;
`

const Container = styled(FormHelperText)`
  ${headShake}
  display: flex;
  gap: 0.25rem;
`

const ErrorMessage: FC<Props> = ({ message, style: styleProp, ...props }) => {
  const [isAnimating, beAnimating] = useState(false)
  const [isMounted, beMounted] = useState(false)
  const {
    formState: { submitCount },
  } = useFormContext<AppointmentFormData>()

  useEffect(() => {
    const timeout = setTimeout(() => beMounted(true), 0)

    return () => clearTimeout(timeout)
  }, [])

  useEffect(() => {
    if (!isMounted) return

    beAnimating(true)

    const timeout = setTimeout(() => beAnimating(false), 1_000)

    return () => clearTimeout(timeout)
  }, [isMounted, submitCount])

  const styles = styleProp ?? {}

  const style = isAnimating
    ? { animationDuration: '1s', animationName: 'headShake', animationTimingFunction: 'ease-in-out', ...styles }
    : styles

  return (
    <Container {...props} aria-live="polite" role="alert" error style={style}>
      {message}
    </Container>
  )
}

export { ErrorMessage }
